'use client'

import {useEffect, useState} from 'react'
import {discoverPartnerStatus} from '../lib/partner-discovery'
import {resolvePartnerSlug} from '../lib/partner-slug'
import {getPublicPartnerProfile} from '../services/public-profile.service'

export interface StudioIdentity {
    slug: string | null
    partnerId: string | null
    displayName: string
    timeZone: string | null
    logoUrl: string | null
    isConfigured: boolean
}

export function useStudioIdentity(fallbackLabel: string): StudioIdentity {
    const partnerSlug = resolvePartnerSlug()
    const [identity, setIdentity] = useState<StudioIdentity>(() => ({
        slug: null,
        partnerId: null,
        displayName: fallbackLabel,
        logoUrl: null,
                timeZone: null,
        isConfigured: false,
    }))

    useEffect(() => {
        let cancelled = false
        if (!partnerSlug) {
            setIdentity({
                slug: null,
                partnerId: null,
                displayName: fallbackLabel,
                logoUrl: null,
                timeZone: null,
                isConfigured: false,
            })
            return () => {
                cancelled = true
            }
        }

        setIdentity({
            slug: partnerSlug,
            partnerId: null,
            displayName: partnerSlug,
            logoUrl: null,
                timeZone: null,
            isConfigured: true,
        })

        void getPublicPartnerProfile(partnerSlug)
            .then(async (profile) => {
                if (cancelled) return
                if (profile) {
                    setIdentity({
                        slug: profile.slug || partnerSlug,
                        partnerId: profile.partnerId,
                        displayName: profile.displayName || partnerSlug,
                        logoUrl: profile.logoUrl,
                        timeZone: profile.timeZone,
                        isConfigured: true,
                    })
                    return
                }

                const status = await discoverPartnerStatus(partnerSlug)
                if (cancelled) return
                if (status.status === 'active' || status.status === 'inactive') {
                    setIdentity({
                        slug: status.slug || partnerSlug,
                        partnerId: null,
                        displayName: status.displayName || partnerSlug,
                        logoUrl: null,
                timeZone: null,
                        isConfigured: true,
                    })
                    return
                }
                setIdentity({
                    slug: partnerSlug,
                    partnerId: null,
                    displayName: partnerSlug,
                    logoUrl: null,
                timeZone: null,
                    isConfigured: true,
                })
            })
            .catch(() => {
                if (!cancelled) {
                    setIdentity({
                        slug: partnerSlug,
                        partnerId: null,
                        displayName: partnerSlug,
                        logoUrl: null,
                timeZone: null,
                        isConfigured: true,
                    })
                }
            })

        return () => {
            cancelled = true
        }
    }, [fallbackLabel, partnerSlug])

    return identity
}
